import { render, staticRenderFns } from "./logo-config.vue?vue&type=template&id=57c66fe0&"
import script from "./logo-config.vue?vue&type=script&lang=ts&"
export * from "./logo-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports